// extracted by mini-css-extract-plugin
module.exports = {"TestPage":"TestPage_TestPage__2sz1r","Title":"TestPage_Title__3G7rl"};